export const xxSmall = 0.375;
export const xSmall = 0.5;
export const small = 0.75;
export const normal = 1;
export const large = 1.25;



// WEBPACK FOOTER //
// ./../src/Button/Sizes.js